import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import {
  faBars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCreditCard,
  faEdit,
  faPen,
  faEllipsisH,
  faHistory,
  faInfo,
  faInfoCircle,
  faListUl,
  faPlus,
  faReceipt,
  faSearch,
  faTimes,
  faTimesCircle,
  faUser,
  faUsers,
  faTrashAlt,
  faDollarSign,
  faUserFriends,
  faBan,
  faTicketAlt,
  faKey,
  faHourglassHalf,
  faAddressCard,
  faBox,
  faBoxes,
  faImages,
  faMoneyCheckAlt,
  faCalendarTimes,
  faCalendarCheck,
  faFile,
  faFileAlt,
  faGlobe,
  faTh,
  faUndo,
  faAddressBook,
  faShoppingBasket,
  faGem,
  faFileExcel,
  faTag,
  faCode,
  faSpider,
  faRunning,
  faShare,
  faShareAlt,
  faExchangeAlt,
  faRandom,
  faMobileAlt,
  faRoute,
  faLock,
  faDoorClosed,
  faHandshake,
  faFileContract,
  faMap,
  faMapMarkedAlt,
  faBuilding,
  faEnvelope,
  faEnvelopeOpenText,
  faChartBar,
  faClipboardList
} from '@fortawesome/free-solid-svg-icons';

const addIcons = () => library.add(
  // SOLID ICONS:
  faUndo,
  faInfo,
  faInfoCircle,
  faHistory,
  faCircle,
  faEdit,
  faPen,
  faCheck,
  faCheckCircle,
  faTimes,
  faTimesCircle,
  faSearch,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faUser,
  faUsers,
  faReceipt,
  faCreditCard,
  faListUl,
  faEllipsisH,
  faPlus,
  faBars,
  faTrashAlt,
  faDollarSign,
  faUserFriends,
  faBan,
  faTicketAlt,
  faKey,
  faHourglassHalf,
  faAddressCard,
  faBox,
  faBoxes,
  faImages,
  faMoneyCheckAlt,
  faCalendarTimes,
  faCalendarCheck,
  faFile,
  faFileAlt,
  faGlobe,
  faTh,
  faAddressBook,
  faShoppingBasket,
  faGem,
  faFileExcel,
  faTag,
  faCode,
  faSpider,
  faRunning,
  faShare,
  faShareAlt,
  faExchangeAlt,
  faRandom,
  faMobileAlt,
  faRoute,
  faLock,
  faDoorClosed,
  faHandshake,
  faFileContract,
  faMap,
  faMapMarkedAlt,
  faBuilding,
  faEnvelope,
  faEnvelopeOpenText,
  faChartBar,
  faClipboardList,
  // BRAND ICONS:
  faFacebookF);

export default addIcons;